import RsaGestionePazientiAdi from "../";

const routes = [
	{
		name: "RsaGestionePazientiAdiListPage",
		path: "/rsagestionepazientiadi",
		component: RsaGestionePazientiAdi.RsaGestionePazientiAdiListPage,
		meta: { title: "R.S.A. - Gestione Ambulatoriale" },
	},
];

export default routes;
